import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';
import { InfoMessage } from '../account/models/info-message.model';

@Injectable()
export class ProfileService {
	registrationSuccessful: boolean = false;

	constructor(private httpClient: HttpClient, private configService: ConfigService) {}

	sendForgotPasswordLink(email: string) {
		return this.httpClient.post<InfoMessage>(this.configService.authApiBaseUrl.concat('User/ForgotPassword'), {
			email: email,
			callbackUrl: this.configService.resetPasswordCallbackUrl
		});
	}

	resetPassword(resetPasswordDto: any) {
		return this.httpClient.post<InfoMessage>(
			this.configService.authApiBaseUrl.concat('User/ResetPassword'),
			resetPasswordDto
		);
	}

	changePassword(changePasswordDto: any) {
		return this.httpClient.post<InfoMessage>(
			this.configService.authApiBaseUrl.concat('User/ChangePassword'),
			changePasswordDto
		);
	}

	registerUser(registrationDto: any) {
		return this.httpClient.post<InfoMessage>(
			this.configService.authApiBaseUrl.concat('User/Registration'),
			registrationDto
		);
	}

	completeRegistration(email: string, token: string, registrationDto: any) {
		return this.httpClient.post<InfoMessage>(
			this.configService.authApiBaseUrl.concat('User/CompleteRegistration'),
			registrationDto,
			{
				params: {
					email: email,
					token: token
				}
			}
		);
	}
}
